import { render } from "./GasCompComponentChart.vue?vue&type=template&id=4763caaf"
import script from "./GasCompComponentChart.vue?vue&type=script&lang=js"
export * from "./GasCompComponentChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__